import { createSelector } from 'redux-orm';

import orm from '../orm';
import { selectPointSystemForCurrentBoard } from './point-systems';

export const selectEmployeePlansForCurrentBoardPointSystem = createSelector(
  orm,
  (state) => selectPointSystemForCurrentBoard(state),
  ({ EmployeePlan }, pointSystem) => {
    if (!pointSystem) {
      return [];
    }

    return EmployeePlan.all()
      .filter({ pointSystemId: pointSystem.id })
      .orderBy('sort')
      .toRefArray();
  },
);

export const makeSelectEmployeePlansByPointSystemId = () =>
  createSelector(
    orm,
    (_, pointSystemId) => pointSystemId,
    ({ EmployeePlan }, pointSystemId) => {
      if (!pointSystemId) {
        return [];
      }

      return EmployeePlan.all()
        .filter({ pointSystemId })
        .orderBy('sort')
        .toRefArray();
    },
  );

export default {
  selectEmployeePlansForCurrentBoardPointSystem,
  makeSelectEmployeePlansByPointSystemId,
};

